export class DatesFilter {
    startDate = 0;
    endDate = 0;

    initFromJson(json) {
        this.endDate = json.endDate;
        this.startDate = json.startDate;
    }

    isEmpty() {
        if (this.startDate != null && this.startDate > 0 && this.endDate != null && this.endDate > 0) {
            return false;
        }
        return true;
    }
}
